import { atom, useAtom } from 'jotai';
import { useMemo } from 'react';
import type { RelativeDOMRect } from './utils/toRelativeDOMRect';

const optimisticItemContentRects = atom(new Map<string, RelativeDOMRect>());

export const useOptimisticItemContentRects = () => {
  const [map, setMap] = useAtom(optimisticItemContentRects);

  return useMemo(
    () => ({
      has: map.has.bind(map),
      get: map.get.bind(map),
      entries: map.entries.bind(map),
      size: map.size,
      remove: (key: string) => {
        setMap((prev) => {
          const next = new Map(prev);
          next.delete(key);
          return next;
        });
      },
      add: (key: string, rect: RelativeDOMRect) => {
        setMap((prev) => {
          const next = new Map(prev);
          next.set(key, rect);
          return next;
        });
      },
    }),
    [map, setMap],
  );
};
